import { Typography } from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useSnackbar } from '@Providers/useSnackbar';
import AttemptModal from '../../StandaloneCourses/Submissions/AttemptModal';
import TestSubmissionCard from '../../StandaloneCourses/Submissions/TestSubmissionCard';
import { endpointsForCourse } from '../../StandaloneCourses/Submissions/endpoints';
import { TestSubmission } from '../../StandaloneCourses/Submissions/Submissions.types';
import usePagedSubmissions from '../Hooks/usePagedSubmissions';
import SubmissionsPager from './SubmissionsPager';
import { SubmissionsFilters, fetchTestSubmissions } from '../Services/submissions.req';

type Props = {
	filters: SubmissionsFilters;
	canGrade: boolean;
	/** bumps whenever a modal closes so the KPI chips refresh too */
	onChanged: () => void;
};

/** Grade a review attempt, regrade a closed one — or only look, without g-sub. */
const actionLabelFor = (row: TestSubmission, canGrade: boolean) => {
	if (!canGrade) return 'View';
	return row.evaluation_status === 'closed' ? 'Regrade' : 'Grade';
};

const GlobalTestSubmissions: React.FC<Props> = ({ filters, canGrade, onChanged }) => {
	const { displaySnackbar } = useSnackbar();
	const [current, setCurrent] = useState<TestSubmission>();
	const { page, setPage, rows, meta, reload } = usePagedSubmissions(
		(activePage) => fetchTestSubmissions(filters, activePage),
		[filters],
		(error: any) => displaySnackbar('error', error?.response?.data?.message ?? 'Unable to load test submissions')
	);

	const closeModal = () => {
		setCurrent(undefined);
		reload();
		onChanged();
	};

	return (
		<div>
			{current && (
				<AttemptModal
					open
					submissionAttempt={current}
					endpoints={endpointsForCourse(current.test.unit.course)}
					readOnly={!canGrade}
					onClose={closeModal}
				/>
			)}
			{rows.length === 0 ? (
				<Empty>{filters.state === 'pending' ? 'No essay attempts awaiting review' : 'No test submissions'}</Empty>
			) : (
				rows.map((row) => (
					<TestSubmissionCard
						key={row.id}
						test={row}
						showProduct
						actionLabel={actionLabelFor(row, canGrade)}
						onClick={(test) => setCurrent(test)}
					/>
				))
			)}
			<SubmissionsPager meta={meta} page={page} shown={rows.length} onChange={setPage} />
		</div>
	);
};

const Empty = styled(Typography)`
	color: #a4a4a4;
	padding: 2rem 0;
	text-align: center;
`;

export default GlobalTestSubmissions;
